/*
 * @Author: zwcong
 * @Description:
 * @Date: 2021-08-17 10:37:30
 * @LastEditTime: 2022-03-09 11:50:52
 * @FilePath: /teacher-h5/src/store/modules/studentDetails.js
 */
const state = {
  subjectList: [], // 科目列表
  gradeList: [], // 年级列表
  activeSubjectId: '', // 当前科目
  activeGradeId: '', // 当前年级
  searchKey: '', // 搜索关键字
  searchKeyWord: '' // 触发搜索关键字
}

// 自定义改变state初始值的方法
const mutations = {
  setSubjectList (state, data) {
    // console.log('data', data)
    data.unshift({
      subjectId: -1,
      subjectName: '全部'
    })

    state.subjectList = data
    state.activeSubjectId = data[0].subjectId
  },
  setGradeList (state, data) {
    // console.log('data', data)
    data.unshift({
      gradeId: -1,
      gradeName: '全部'
    })

    state.gradeList = data
    state.activeGradeId = data[0].gradeId
  },
  setActiveSubjectId(state, data) {
    state.activeSubjectId = data
  },
  setActiveGradeId(state, data) {
    state.activeGradeId = data
  },
  setSearchVal(state, val) {
    state.searchKey = val
  },
  setSearchKeyWord(state, val) {
    console.log('setSearchKeyWord', val)
    state.searchKeyWord = val
  }
}

// 自定义触发mutations里函数的方法
const actions = {
  // disInfo ({ commit }, obj) {
  //   commit('setInfo', obj)
  // },
  // disCardList({ commit }, data) {
  //   commit('setCardList', data)
  // }
}

const getters = {
  subjectList: state => state.subjectList,
  gradeList: state => state.gradeList,
  activeSubjectId: state => state.activeSubjectId,
  activeGradeId: state => state.activeGradeId,
  searchKey: state => state.searchKey,
  searchKeyWord: state => state.searchKeyWord
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
